var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDeleteItem(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.5166 0.0457764C4.0791 0.0457764 0.516602 3.63953 0.516602 8.04578C0.516602 12.4833 4.0791 16.0458 8.5166 16.0458C12.9229 16.0458 16.5166 12.4833 16.5166 8.04578C16.5166 3.63953 12.9229 0.0457764 8.5166 0.0457764ZM11.0166 9.51453C11.2979 9.82703 11.2979 10.2958 11.0166 10.577C10.7041 10.8895 10.2354 10.8895 9.9541 10.577L8.5166 9.10828L7.0166 10.577C6.73535 10.8895 6.2666 10.8895 5.98535 10.577C5.67285 10.2958 5.67285 9.82703 5.98535 9.51453L7.4541 8.04578L5.98535 6.57703C5.67285 6.26453 5.67285 5.79578 5.98535 5.51453C6.2666 5.20203 6.73535 5.20203 7.0166 5.51453L8.5166 7.01453L9.98535 5.54578C10.2666 5.23328 10.7354 5.23328 11.0166 5.54578C11.3291 5.82703 11.3291 6.29578 11.0166 6.60828L9.54785 8.07703L11.0166 9.51453Z",
    fill: "#037A9A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteItem);
export default __webpack_public_path__ + "static/media/DeleteItem.36470227d5197c5a46f56aab15889b8f.svg";
export { ForwardRef as ReactComponent };